module.exports = __webpack_public_path__ + "assets/img/pay2House.0714bd3a.svg";